import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlugin1"><Path d="M19.5 14.5L19.5 6.5H4.5V14.5C4.5 16.7091 6.29086 18.5 8.5 18.5H15.5C17.7091 18.5 19.5 16.7091 19.5 14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 6.5L15.5 2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 18.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 6.5L8.5 2.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlugin1;
